import Swal from "sweetalert2";

export function AlertModal(data, type, showConfirmButton = false, title = null, confirmButtonText = 'OK', showCancelButton = false) {
    if (showConfirmButton) {
        Swal.fire({
            icon: type,
            title,
            text: data,
            showConfirmButton: true,
            confirmButtonText,
            showCancelButton
        })
    } else {
        Swal.fire({
            icon: type,
            title,
            text: data,
            showConfirmButton: false,
            timer: 3000
        })
    }
}